function Image({ width, height, className, source, alternativetext, caption }) {
  return (
    <>
      <img
        width={width || "auto"}
        height={height || "auto"}
        className={className}
        src={source}
        alt={alternativetext}
      />
      {caption && <p className="image-caption text-muted">{caption}</p>}
    </>
  );
}

export default Image;
